import pixelartShow from "./pixelmodelshow.vue";
import particleList from "./particleList.vue";
export default {
  emits: ["onClicklike", "onGetPDF"],
  components: {
    pixelartShow,
    particleList
  },
  data() {
    return {};
  },
  props: {
    show: {
      Type: Boolean,
      default: true
    },
    currentEffectimg: {
      // 当前选中的像素画数据
      Type: Object
    },
    assembleButImg: {
      // 拼装按钮图片
      Type: String
    },
    currentimgInfo: {
      //当前选中的像素画数据
      Type: Object
    },
    currentSeqdata: {
      //当前选中的序列数据
      Type: Object
    }
  },
  watch: {},
  computed: {
    hasOnBuildDetail() {
      // 检查是否存在 'onBuildDetail' 监听器
      // console.log("pixelArtDetails attr", this.$attrs);
      // console.log("pixelArtDetails hasOnBuildDetail", this.$attrs.onBuildDetail);

      // return !!this.$attrs.onBuildDetail;
      return typeof this.$attrs.onBuildDetail === 'function';
    }
  },
  methods: {
    //点击拼装按钮
    onHandleBuild() {
      this.$attrs.onBuildDetail();
    },
    //点击获取PDF按钮
    onGetPDF() {
      this.$emit("onGetPDF", this.currentimgInfo);
    },
    //点击喜欢按钮
    onClicklike(currentimgInfo) {
      // console.log("pixelArtDetails onClicklike", imginfo);
      // console.log("pixelArtDetails onClicklike ---- ", currentimgInfo);

      this.$emit("onClicklike", currentimgInfo);
    },
    onScrollIntoPixelartShow() {
      this.$refs.pixelartShow.scrollIntoView({
        behavior: "smooth",
        block: "nearest"
      });
    }
  }
};